import MobileMenuFulfillmentShortcuts from "./MobileMenuFulfillmentShortcuts";
export default MobileMenuFulfillmentShortcuts;
